import {
    CREATING_HUBSPOT_FORM_REQUEST, CREATING_HUBSPOT_FORM_SUCCEDDED, CREATING_HUBSPOT_FORM_FAILED,
    UPDATING_HUBSPOT_FORM_REQUEST, DELETING_HUBSPOT_FORM_SUCCEEDED, DELETING_HUBSPOT_FORM_FAILED,
    DELETING_HUBSPOT_FORM_REQUEST, UPDATING_HUBSPOT_FORM_SUCCEEDED, UPDATING_HUBSPOT_FORM_FAILED
} from 'constants/actionTypes';

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';

const apiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}/api/1.0`;
const HUBSPOT_FORM_URL = `${apiUrl}/forms/hubspot`;

/*
* Create Form
*/
export const createHubspotForm = createAction(CREATING_HUBSPOT_FORM_REQUEST, (request) => {
    return {
        request: request
    };
})

const creatingHubspotFormSucceeded = createAction(CREATING_HUBSPOT_FORM_SUCCEDDED, (response) => {
    return response;
})

const creatingHubspotFormFailed = createAction(CREATING_HUBSPOT_FORM_FAILED, (error) => {
    return error;
})

function* createHubspotFormSaga(action) {
    const { request } = action.payload;

    const createHubspotFormAPI = () => {
        return axios.post(HUBSPOT_FORM_URL, request).then(response => response.data);
    }

    try {
        const response = yield call(createHubspotFormAPI);
        if (response) {
            yield put(creatingHubspotFormSucceeded(response));
        }
    } catch (error) {
        yield put(creatingHubspotFormFailed(error));
    }
}


/**
 * Update form
 */
export const updateHubspotForm = createAction(UPDATING_HUBSPOT_FORM_REQUEST, (request) => {
    return {
        request: request
    }
})

const updatingHubspotFormSucceeded = createAction(UPDATING_HUBSPOT_FORM_SUCCEEDED, (response) => {
    return response;
})

const updatingHubspotFormFailed = createAction(UPDATING_HUBSPOT_FORM_FAILED, (formId, error) => {
    return {
        formId: formId,
        error: error
    }
})

function* updateHubspotFormSaga(action) {
    const { request } = action.payload;

    const updateHubspotFormAPI = () => {
        return axios.put(HUBSPOT_FORM_URL, request).then(response => response.data);
    }

    try {
        const response = yield call(updateHubspotFormAPI);
        yield put(updatingHubspotFormSucceeded(response));
    } catch (error) {
        yield put(updatingHubspotFormFailed(request.id, error));
    }
}

/**
 * Delete form
 */
export const deleteHubspotForm = createAction(DELETING_HUBSPOT_FORM_REQUEST, (type, formId) => {
    return {
        type: type,
        formId: formId
    }
})

const deletingHubspotFormSucceeded = createAction(DELETING_HUBSPOT_FORM_SUCCEEDED, (type, formId) => {
    return {
        type: type,
        formId: formId
    }
})

const deletingHubspotFormFailed = createAction(DELETING_HUBSPOT_FORM_FAILED, (type, formId, error) => {
    return {
        type: type,
        formId: formId,
        error: error
    }
})

function* deleteHubspotFormSaga(action) {
    const { type, formId } = action.payload;

    const params = {
        formId: formId
    };

    let url = buildUrl(HUBSPOT_FORM_URL, {
        queryParams: params
    });

    const deleteHubspotFormAPI = () => {
        return axios.delete(url).then(response => response.data);
    }

    try {
        const response = yield call(deleteHubspotFormAPI);
        yield put(deletingHubspotFormSucceeded(type, formId));
    } catch (error) {
        yield put(deletingHubspotFormFailed(type, formId, error));
    }
}

export default function* hubspotFormsSaga() {
    yield takeEvery(CREATING_HUBSPOT_FORM_REQUEST, createHubspotFormSaga)
    yield takeEvery(UPDATING_HUBSPOT_FORM_REQUEST, updateHubspotFormSaga)
    yield takeEvery(DELETING_HUBSPOT_FORM_REQUEST, deleteHubspotFormSaga)
}